module.exports = __webpack_public_path__ + "static/media/xlsx.947b158e.png";